// 长任务控制
// 任务1：batchPack 代理人批量打包任务

import {batchPack,
  confirmationTaskGet,
  getAgentDocPackStatus,
  updateStatusById,
  confirmationProgress,
  confirmationExport, confirmationTaskDel} from '@/assets/js/api';
import {Message} from '@com.thunisoft.9law/element-ui';

export default {
  state: {
    // 2 导入 1 导出
    taskType: '',
    // 司法确认长任务
    confirmationExport: {
      id: '',
      status: 0,
      url: '',
      code: '',
      msg: '',
      details: []
    },
    batchPack: {
      id: '',
      status: 4
    }
  },
  mutations: {
    SET_TASK_TYPE: (state, taskType) => {
      state.taskType = taskType;
    },
    SET_TASK_BATCH_PACK: (state, {
      key, value
    }) => {
      state.batchPack[key] = value;
    },
    SET_CONFIRMATION_EXPORT: (state, {
      key, value
    }) => {
      state.confirmationExport[key] = value;
    },
  },
  actions: {
    // 获取任务
    async CreateTaskBatchPack({commit}, params) {
      const result = await batchPack(params);
      if (result.code === 200 && result.data) {
        await getAgentDocPackStatus()
          .then(res => {
            if (res.code === 200) {
              commit('SET_TASK_BATCH_PACK', {key: 'id', value: res.data.taskId});
              commit('SET_TASK_BATCH_PACK', {key: 'status', value: res.data.taskStatus});
            }
          });
      } else {
        Message.error(result.msg);
      }
    },
    // 查询任务
    async QueryTaskBatchPack({commit}) {
      const {
        code, data
      } = await getAgentDocPackStatus();
      if (code === 200 && data) {
        commit('SET_TASK_BATCH_PACK', {key: 'id', value: data.taskId});
        commit('SET_TASK_BATCH_PACK', {key: 'status', value: data.taskStatus});
        return data;
      } else {
        commit('SET_TASK_BATCH_PACK', {key: 'id', value: ''});
        commit('SET_TASK_BATCH_PACK', {key: 'status', value: ''});
      }
    },
    // 结束任务
    async EndTaskBatchPack({commit}, id) {
      await updateStatusById({
        id,
        status: 5
      })
        .then(res => {
          if (res.code === 200) {
            commit('SET_TASK_BATCH_PACK', {key: 'id', value: ''});
            commit('SET_TASK_BATCH_PACK', {key: 'status', value: ''});
          }
        });
    },
    // 司法确认补填信息导出
    // 获取任务
    ConfirmationTaskGet({commit}, params) {
      return new Promise(async (resolve, reject) => {
        const result = await confirmationTaskGet(params);
        if (result.code === 200 && result.data) {
          commit('SET_TASK_TYPE', result.data.type);
          commit('SET_CONFIRMATION_EXPORT', {key: 'id', value: result.data.bizNo});
          commit('SET_CONFIRMATION_EXPORT', {key: 'status', value: 2});
          if (result.data.type === 2) {
            resolve();
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },
    // 创建任务
    async ConfirmationExport({commit}, params) {
      const result = await confirmationExport(params);
      if (result.code === 200 && result.data) {
        commit('SET_CONFIRMATION_EXPORT', {key: 'id', value: result.data});
        commit('SET_CONFIRMATION_EXPORT', {key: 'status', value: ''});
        commit('SET_TASK_TYPE', 1);
      } else if (result.msg) {
        Message.error(result.msg);
      }
    },
    // 查询任务状态
    async ConfirmationProgress({
      commit, state
    }) {
      const {
        code, data
      } = await confirmationProgress({bizNo: state.confirmationExport.id});
      if (code === 200 && data) {
        return data;
      } else {
        commit('SET_CONFIRMATION_EXPORT', {key: 'id', value: ''});
        commit('SET_CONFIRMATION_EXPORT', {key: 'status', value: ''});
      }
    },
    // 结束任务
    async ConfirmationTaskDel({commit}) {
      await confirmationTaskDel()
        .then(res => {
          if (res.code === 200) {
            commit('SET_CONFIRMATION_EXPORT', {key: 'id', value: ''});
            commit('SET_CONFIRMATION_EXPORT', {key: 'status', value: 0});
          }
        });
    },

  }
};
